<template>
  <div class="wrap">
    <template v-if="!(isPureType && !removePureItem)">
      <div class="wrap-item" v-if="this.tbFormVm.schemas && this.tbFormVm.schemas.customSaleProp">
        <div class="wrap-item_label required-label">选择展示模式</div>
        <div class="wrap-item_content">
          <Radio :props="{dataSource: showModeObj, name: showModeObj.name }" @change="showModeChange"/>
        </div>
      </div>
      <div v-if="sizeGroupObj && !isPureType" class="wrap-item">
        <div class="wrap-item_label required-label">{{sizeGroupObj.label}}</div>
        <div class="wrap-item_content">
          <Radio ref="radioRef" :props="{dataSource: sizeGroupObj, name: sizeGroupObj.name}" :isSizeGroup="true" @change="sizeGroupChange"/>
        </div>
      </div>
      <div class="wrap-item">
        <div class="wrap-item_label required-label">商品规格</div>
        <div class="wrap-item_content">
          <RuleSortBtn v-if="!isPureType" class="inline-block" :specifications.sync="specifications" />
          <SpecsValuesSort v-if="!isPureType" :specifications.sync="specifications" />
          <div v-if="removePureItem" class="inline-block" style="margin-left: 10px;">
            <el-checkbox :value="tbForm.pureType" :disabled="tbFormVm.pureTypeDisabled" :true-label="1" :false-label="0" @change="changePureType">纯商品</el-checkbox>
            <el-tooltip effect="dark" content="勾选后支持纯商品发布，商品规格信息不生效" placement="top">
              <i class="el-icon-question help-icon" />
            </el-tooltip>
          </div>
          <FormItemSpecification
            v-if="!isPureType"
            ref="formItemSpecificationRef"
            v-model="specifications"
            :isPlatform="true"
            :platform="platform"
            remarkKey="note"
            :changeToBase="tbFormVm.changeToBase"
            :showAuditResult="$attrs.showAuditResult"
            :auditFileList="$attrs.auditFileList"
            :imgAttr="imgAttr"
            @file-upload="handleImageUpload" 
          />
        </div>
      </div>
      <div v-if="!isPureType" class="wrap-item">
        <div class="wrap-item_label required-label">商品明细</div>
        <div class="wrap-item_content">
          <FormItemSkuList
            :baseItemId="tbFormVm.form.baseItemId"
            :specifications="specifications"
            :imgOnlyPreview="skuImgOnlyPreview"
            :tableCols="skuTableCols_all"
            skuOuterIdKey="skuOuterId"
            :showBindSkuOuterId="openSource !== 'shopGoods'"
            @skuFieldBlur="handleSkuFieldBlur"
            @fieldChanged="specificationsFieldChanged"
            v-model="skuList">
            <template slot="skuDeliveryTimeHeaderSlot">
              <span style="color: red">*</span>预售发货时间
              <el-tooltip
                class="item"
                effect="dark"
                content="按sku设置预售，需录入预售的发货时间，默认为平台发货时效（2天内发货）"
                placement="top">
                <i style="margin-left: 5px; margin-right: 5px;" class="el-icon-question" />
              </el-tooltip>
            </template>
            <template slot="skuPictureSlot" slot-scope="{ row,$index }">
                <div style="padding: 8px 0;">
                    <ImgUpload
                      :width="80"
                      :ref="`search_img_${$index}`"
                      :height="80"
                      :aspectRatio="[1, 0.75]"
                      aspectRatioText="1:1或3:4"
                      :limitSize="3 * 1024 * 1024"
                      :size="120"
                      :limitWidth="[480, 0]"
                      :limitHeight="[480, 0]"
                      :file="row.skuPicture"
                      :isSingle="true"
                      @upload-success="url => handleSearchImagesChanged(row, url,$index)"
                      @handleLoad="handleImgLoad(row, `search_img_${$index}`,$index)"
                      @del="() => handleSearchImagesChanged(row, '',$index)"
                    />
                </div>
            </template>
          </FormItemSkuList>
          <template v-if="tbFormVm.specificationsValidResult !== true">
            <div class="el-form-item__error">{{tbFormVm.specificationsValidResult}}</div>
          </template>
        </div>
      </div>
      <div class="wrap-item" v-if="sizeMappingsSchema.length && !isPureType">
        <div class="wrap-item_label" :class="{'required-label': isSizeMapRequired}">尺码表</div>
        <div class="wrap-item_content">
          <StdSizeExtends
            ref="StdSizeExtendsRef"
            :isSizeMapRequired="isSizeMapRequired"
            :specifications="specifications"
            :schema="sizeMappingsSchema"
            :sizeNameKey="sizeNameKey"
            @fieldChanged="specificationsFieldChanged"
          >
          </StdSizeExtends>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {specification_mixin} from '@/components/prod/center/components/FormItemSpecification'
import storeMixins from '../store-mixins'
import Radio from '../Radio'
import ImgUpload from "@/components/Uploads/ImgUpload";

import FormItemSpecification from './Specifications/FormItemSpecification.vue'
import StdSizeExtends from './StdSizeExtends.vue';
import { genIsShowFn } from '../../utils/disableRule'
import { cloneDeep } from 'lodash'
import platform from '@/utils/platform';

export default {
  components: {
    Radio,
    FormItemSpecification,
    StdSizeExtends,
    ImgUpload,
  },
  provide() {
    return {
      disabledSpName: true,
      platform: "tb",
      noSpPic: this.specifications.length && !this.specifications[0].valueAttributeRuleList.includes('img'),
      getSpecifications: this.method_getData,
      sizeGroupObj:this.sizeGroupObj,
      getOptions: this.getOptions,
    }
  },
  inject: {
    tbFormVm: {
      default: {}
    },
    openSource:{default:null},
    isGroupPuhuo: { // 是否组合铺货
      default: false
    },
  },
  mixins: [specification_mixin, storeMixins],
  props: ["props"],
  data() {
    return {
      isTb: true,
      platform: "tb",
      saleProp: {},
      skuSpecificationsKey: "skuSpecifications",
      schemaSpecifications: [],
      skuImgOnlyPreview: true, // sku的预览图是否只能预览不能编辑
      self_form: {}, // 与别的平台不同，为了兼容使用规格组件，将skuList初始化到这个对象
      sizeGroupObj: null, // 尺码分组
      sizeValueObj: null,
      propsMap: {}, // 销售属性下的子属性索引
      spIndexMap: {}, // 规格下标索引，防止平台规格顺序调整，编码匹配不上
      imgAttr: {},
      skuParamsSchemas: [],
      skuSearchImg:[], // sku搜索图相关
      sizeMappingsSchema: [],
      sizeNameKey: '',
      isSizeMapRequired: false
    }
  },
  computed: {
    isPureType() {
      return this.tbForm.pureType
    },
    skuTableCols_all() {
      const deliveryTimeBySku = this.tbForm.deliveryTimeType === '2' && this.tbForm.deliveryTimeSetBySku === '1'
      const originIsDistribution = JSON.parse(localStorage.getItem('_origin_form'))?.isDistribution == 0
      const skuChildren = this.tbFormVm.schemas?.sku?.children || [];
      // 如果是按SKU设置预售时间，设置默认值
      if(deliveryTimeBySku) {
        this.setSkuDeliveryTimeDefault();
      }
      const createColumn = (item,parentItem={}) => {
        const { name, label, options, type, rules } = item
        const { requiredRule, tipRule } = rules || {}
        const items = (options || []).map(op => ({label: op.displayName, value: op.value}))
        const inputType = ['SINGLECHECK', 'MULTICHECK'].includes(type) ? 'select' : 'text'
        let obj = {
          prop: name,
          attrs: { 
            label,
            width: 130,
            noRequired: requiredRule !== 'true',
            'header-tooltip': tipRule
          },
          input: { 
            type: inputType, 
            onlyTable: false, 
            attrs: { filterable: true, multiple: type === 'MULTICHECK' },
          },
          items,
          disabledFn: (row) => {
            const disabled = item.isShowFn ? !item.isShowFn(row) : false
            if(disabled) {
              row[name] = ''
            }
            return disabled
          }
        }
        if(parentItem.name === 'skuPicture'){ //SKU搜索图处理
            obj.prop = 'skuPicture'
            obj.slot = true
        }
        if(parentItem.name === 'skuTitle'){ //SKU搜索标题
            obj.attrs.label = 'SKU搜索标题'
            obj.isCustomValidator = true
            obj.input.validator = (value,props,row) => {
              let _skuid = row._skuid;
              let errMsg = '字符长度控制在10~15个汉字（30个字符以内）'
              let index = this.skuList.findIndex(i => i._skuid === _skuid)
              if(value){
                  const chineseCharRegex = /[\u4e00-\u9fa5]/;
                  let totalLength = 0;
                  for (let i = 0; i < value.length; i++) {
                      // 如果是中文字符，计为2；否则计为1
                      totalLength += chineseCharRegex.test(value[i]) ? 2 : 1;
                      if (totalLength > 30) {
                          this.$set(this.skuList[index],props.prop+'Error',errMsg)
                          return 'SKU搜索标题:'+errMsg;
                      }
                  }
                  if(totalLength < 10){
                    this.$set(this.skuList[index],props.prop+'Error',errMsg)
                    return 'SKU搜索标题:'+errMsg;
                  }
                  this.$delete(this.skuList[index], props.prop+'Error')
                  return true
              }else{
                 this.$delete(this.skuList[index], props.prop+'Error')
              }
            }
        }
        if(['skuPicture','skuTitle'].includes(parentItem.name)){
            const { rules } = parentItem
            const { requiredRule, tipRule } = rules || {}
            obj.input.onlyTable = true
            if(!obj.attrs['header-tooltip']){
              obj.attrs['header-tooltip'] = tipRule
            }
        }
        return obj
      }
      let openSource = this.openSource
      let isShowPreviewPrice = true;
      if(['taskCenter','previewPublish'].includes(openSource)){
          isShowPreviewPrice = false
      }
      const cols = [
        { prop: 'skuPrice', attrs: {label: '价格'}, input: {type: 'number', attrs: { precision: 2 }}, previewPrice: isShowPreviewPrice},
        !originIsDistribution && deliveryTimeBySku ? { prop: 'skuSupplyPrice', attrs: { label: '供货价',noRequired: true }, input: {type: 'number', attrs: { precision: 2 }}, unvisible: originIsDistribution } : null, //  // 供货价列（仅在非分销且按SKU设置预售时显示）
        { prop: 'skuStock', attrs: {label: '数量'}, input: {type: 'number', attrs: {precision: 0}}, disabledFn: (row) => (this.isPureType || row.stockType === 1)},
         this.openSource != 'shopGoods' ? { prop: 'skuOuterId', attrs: {label: '基础资料商家编码', width: 160, noRequired: this.isGroupPuhuo, headerTooltip: this.isGroupPuhuo ? '' : '必填，用于关联基础资料规格明细'}, input: {type: 'text', onlyTable: true}} : null,
        { prop: 'outSkuPlatform', attrs: { label: '平台规格编码', noRequired: true, width: 160, headerTooltip: '平台规格编码，对应平台sku外部商家编码，用于管理商品，并匹配ERP商品' }, input: { type: 'text' } },
        deliveryTimeBySku ? { prop: 'skuDeliveryTime', attrs: {label: '预售发货时间', width: 130},  input: {type: 'select'} , items: this.skuTimeOptions, headerSlot: true } : null, // 预售发货时间列（按SKU设置预售时显示）
      ]
      // skuParamsSchemas 处理逻辑 必填的放在前面
      const sortSkuParams = this.skuParamsSchemas.sort((a,b) => {
          let aRequired = a.rules?.requiredRule === 'true' ? 1 : 0;
          let bRequired = b.rules?.requiredRule === 'true' ? 1 : 0;
          if(a.children?.length){
            aRequired = a.children.some(item => item.rules?.requiredRule === 'true') ? 1 : 0
          }
          if(b.children?.length){
            bRequired = b.children.some(item => item.rules?.requiredRule === 'true') ? 1 : 0
          }
          return bRequired - aRequired
        }) 
      let skuParams = [...this.skuSearchImg,...sortSkuParams]
      skuParams.forEach(skuParam => {
        const disableRule = skuParam.rules?.disableRule
        if(skuParam.children?.length) {
          skuParam.children.forEach(skuChild => {
            skuChild.rules = { disableRule, ...skuChild.rules }
            genIsShowFn(skuChild)
            cols.push(createColumn(skuChild,skuParam))
          })
        } else {
          genIsShowFn(skuParam)
          cols.push(createColumn(skuParam,skuParam))
        }
      })
      return cols.filter(Boolean)
    },
    skuTimeOptions() {
      try {
        let skuDeliveryTimeItem = (this.tbFormVm.schemas?.sku?.children || []).find(item => item.name === "skuDeliveryTime");
        let options = skuDeliveryTimeItem.options.map(op => {
          return {
            label: op.displayName,
            value: op.value
          }
        })
        return options;
      } catch (error) {
        console.log(error, '---computed_skuTimeOptions')
        return []
      }
    },
    showModeObj() {
      return {
        name: 'showMode',
        label: '选择展示模式',
        options: [
          {
            displayName: '单层·自定义规格',
            value: 'single-custom'
          },
          {
            displayName: '分层·自选属性',
            value: 'multi-select'
          }
        ]
      }
    },
  },
  watch: {
    props: {
      immediate: true,
      handler(v) {
        this.init()
      }
    },
    skuList(v) {
      if(!this.isPureType) {
        this.handleSkuFieldBlur('skuStock'); // 计算一次总数量
      }
    },
  },
  methods: {
    init(specs) {
      const v = this.props;
      this.imgAttr = v.imgAttr;
      let saleProp = v.dataSource;
      let _specifications = [];
      let _imgItems = []
      if(this.tbForm.showMode === 'single-custom') {
        saleProp = {
          children: [{
            label: '商品规格',
            name: 'custom_saleProp',
            _oriRules: { requiredRule: 'true', valueAttributeRule: 'img'}
          }]
        }
      }
      this.saleProp = saleProp
      const originSpecifications = cloneDeep(specs || this.tbData.specifications || [])
      const propertie = saleProp.properties?.length ? saleProp.properties[0] : {}
      const isAllChecked = propertie.key === 'isWithoutPair' && propertie.value === 'false'
      saleProp.children.forEach(item => {
        let _item = {
          name: item.label,
          nameKey: item.name,
          values: [],
          options: item.options,
          properties: item.properties,
          valueAttributeRuleList: item._oriRules?.valueAttributeRule ? item._oriRules.valueAttributeRule.split(';') : [],
          disabled: item._oriRules?.requiredRule === 'true' || isAllChecked,
          checked: item._oriRules?.requiredRule === 'true' || isAllChecked
        }
        _specifications.push(_item)
        if (_item.valueAttributeRuleList.includes('img')) {
          _imgItems.push(_item)
        }
      })
      // 图片规格要在最前面
      if (_imgItems.length) {
        let withImage = _imgItems.find(it => {
          const ori = originSpecifications.find(s => s.name === it.name)
          return ori && ori.values && ori.values[0] && !!ori.values[0].imageUrl
        })
        if(!withImage) {
          withImage = _imgItems.find(it => {
          const ori = originSpecifications.find(s => s.name.includes(it.name) || it.name.includes(s.name))
          return ori && ori.values && ori.values[0] && !!ori.values[0].imageUrl
        })
        }
        const candidate = withImage || _imgItems[0]
        const idx = _specifications.findIndex(it => it.name === candidate.name)
        if (idx > 0) {
          const [sp] = _specifications.splice(idx, 1)
          _specifications.unshift(sp)
        }
      }
      this.oldSpecifications = originSpecifications
      this.schemaSpecifications = _specifications;
      this.initSizeGroup()
      this.initSome()
    },
    initSome() {
      this.initPropsMap()
      this.initSkuParams()
      this.initSizeMapping()
      this.initSpecifications()
      this.initSelfSkuList()   
    },
    sizeGroupChange() {
      this.initSome()
    },
    showModeChange() {
      let specifications = cloneDeep(this.specifications);
      if(this.tbForm.showMode === 'single-custom') {
        const singleCustomSpce = {
          checked: true,
          name: '商品规格',
          nameKey: 'custom_saleProp',
          values: [],
        } 
        const forEach = (arr, index = 0, c_arr = []) => {
          // 取到最后一层开始作业务逻辑
          if (arr.length === index) {
            let imageUrl = c_arr.find(item => item.imageUrl)?.imageUrl || ''
            let value = c_arr.map(item => item.value).join('')
            const valueKeys = c_arr.filter(item => !!item.valueKey).map(item => item.valueKey)
            let valuesItem = {
              name: '商品规格',
              nameKey: 'custom_saleProp',
              checked: true,
              imageUrl,
              value,
              valueKey: valueKeys.join('______') ,
            }
            singleCustomSpce.values.push(valuesItem)
            return
          }
          // 取出一层
          let currItem = arr[index]
          // 此层值循环
          currItem.values.forEach(c => {
            // 每个值再递归取
            forEach(arr, index + 1, c_arr.concat(c))
          })
        }
        forEach(specifications?.filter((item) => item?.name && item?.checked));
        specifications = [singleCustomSpce]
        // console.log(cloneDeep(specifications), cloneDeep(this.skuList), cloneDeep(this.self_form.skuList), '---showModeChange--')
      } else {
        specifications.forEach(item => {
          item.values.forEach(val => {
            delete val.valueKeys
          })
        })
      }
      this.init(specifications)
    },
    // 对skuList中的预售时间设置默认2天的值
    setSkuDeliveryTimeDefault() {
      this.skuList.forEach(item => {
        if (!item.skuDeliveryTime) {
          item.skuDeliveryTime = '2'
        }
      })
    },

    // 处理skuList表格内的输入控件失焦处理
    handleSkuFieldBlur(field) {
      if (field === 'skuStock') {
        // 数量失焦需要计算总数量给quantity
        let quantity = 0
        this.skuList.forEach(({skuStock}) => {
          quantity += Number(skuStock) || 0
        });
        this.updateTbForm({
          quantity
        })
      }
    },
     // 验证规格图片
    valiSkuImgs() {
      const imgErrMsgs = this.$refs.formItemSpecificationRef?.imgErrMsgs
      if(imgErrMsgs && Object.values(imgErrMsgs).find(err => err)){
        this.$message.error('商品明细：规格图片大小超过限制')
        return false
      }
      return true
    },

    // 初始化子属性索引
    initPropsMap() {
      const map = {}
      if(this.tbForm.showMode ==='single-custom') {
        this.propsMap = {
          '商品规格': {
            propId: '',
            values: [],
            children: []
          }
        }
        return
      }
      this.saleProp.children.forEach(it => {
        const item = cloneDeep(it)
        map[item.label] = {
          propId: item.name,
          values: item.options,
          children: item.children
        }
      })
      let specifications = this.oldSpecifications
      // 判断是否含有自定义规格
      // if(specifications.find(item => item.nameKey.includes('custom_'))) {
      //   specifications.forEach(it => {
      //     const item = cloneDeep(it)
      //     if(item.nameKey.includes('custom_')) {
      //       map[item.name] = {
      //         propId: item.nameKey,
      //         values: [],
      //         children: item.children
      //       }
      //     }
      //   })
      // }

      this.propsMap = map
    },
    // 初始化规格信息的数据
    initSpecifications() {
      let canUseSpecificationsIndex = [] // 可使用的详情数据下标

      // 详情数据
      let specifications = this.oldSpecifications
      canUseSpecificationsIndex = specifications.map((item, index) => index) // 初始化可用下标
      this.self_form.specifications = JSON.parse(JSON.stringify(specifications))
      // 当前规格信息
      let curr_specifications = JSON.parse(JSON.stringify(this.schemaSpecifications))
      // 判断是否含有自定义规格
      // if(specifications.find(item => item.nameKey.includes('custom_'))) {
      //   specifications.forEach(item => {
      //     if(item.nameKey.includes('custom_')) {
      //       let valueAttributeRuleList = []; 
      //       const hasNote = item.values.some(spv => spv.note)
      //       if(hasNote) valueAttributeRuleList.push('remark')
      //       curr_specifications.push({ ...item, valueAttributeRuleList, properties: []})
      //     }
      //   })
      // }
      // 当前规格信息中未与详情数据匹配到的下表索引
      let noMatchSpIndexArr = []
      // 对当前的规格信息遍历
      curr_specifications.forEach((element, elementIndex) => {
        const sizeGroupName = this.sizeGroupObj?.name || ''
        if(this.sizeGroupObj && this.sizeValueObj && sizeGroupName.startsWith(element.nameKey)) {
          const findSizeItem = this.sizeValueObj.find(size => size.name === `size-${this.tbForm[sizeGroupName]}`)
          if(findSizeItem) {
            element.type = findSizeItem.type;
            element.options = findSizeItem.options;
            element.properties = findSizeItem.properties;
            element.valueAttributeRuleList = findSizeItem._oriRules?.valueAttributeRule ? findSizeItem._oriRules.valueAttributeRule.split(';') : [];
          }
        }
        const { name, properties, options } = element || {};
        if (options && options.length) {
          element.formType = 'select';
        }
        if(properties && properties.length) {
          const propertie = properties[0];
          if(propertie?.type === 'taoSirProperty') {
            element.formType = 'taoSirProperty';
          }
        }
        let existSpIndex = specifications.findIndex(item => item.name === name)
        // 若详情数据中有相同规格名数据
        if (existSpIndex > -1) {
          element.checked = true
          canUseSpecificationsIndex.splice(canUseSpecificationsIndex.indexOf(existSpIndex), 1) // 可用下标-1
          this.spIndexMap[elementIndex] = existSpIndex
          let existSp = specifications[existSpIndex]
          let _specification = curr_specifications[elementIndex]
          _specification.nameKey = _specification.nameKey || existSp.nameKey 
          _specification.values = existSp.values.map(sv => {
            return {
              ...sv,
              name: _specification.name || existSp.name,
              nameKey: _specification.nameKey || existSp.nameKey,
              valueErrorMsg: ''
            }
          })
        } else {
          noMatchSpIndexArr.push(elementIndex)
        }
      });
      // 未匹配的规格 --- 将详情数据剩余的数据按顺序赋给未匹配的
      noMatchSpIndexArr.forEach(index => {
        let _specification = curr_specifications[index]
        if (canUseSpecificationsIndex.length < 1) { // 没有可用下标了
          const { rules = {} } = _specification.ui || {};
            _specification.values = [{
              checked: true,
              name: "",
              nameKey: "",
              orderId: 999,
              value: "无规格",
              valueKey: "",
              valueErrorMsg: ''
            }]
        } else {
          // 使用剩余的下标
          let canUseIndex = canUseSpecificationsIndex.shift()
          const { name = '', nameKey = '',values = [] } = specifications[canUseIndex] || {}
          _specification.checked = true
          _specification.nameKey = _specification.nameKey || nameKey || name
          _specification.values = values.map(sv => {
            return {
              ...sv,
              name: sv.name || name,
              nameKey: sv.nameKey || nameKey,
              valueErrorMsg: ''
            }
          })
          this.spIndexMap[index] = canUseIndex
        } 
      })
      // 过滤掉不需要的规格
      this.specifications = curr_specifications.filter(item => !!item);
    },
    // 初始化skuList
    initSelfSkuList() {
      let _skuList = this.tbData.skuList.map(item => {
        let skus = [...item[this.skuSpecificationsKey]];
        let sortSkus = []
        this.specifications.forEach((item, index) => {
          if (this.spIndexMap[index] === undefined) return;
          sortSkus[index] = skus[this.spIndexMap[index]]
        })
        // 过滤掉规格名没有勾选的项，不参与组合_skuid
        let _skuid = sortSkus.filter(skuSp => {
          if(!skuSp) return
          const findSp = this.specifications.find(sp => (sp.values[0]?.name === skuSp.name || sp.values[0]?.nameKey === skuSp.nameKey || sp.name === skuSp.name || sp.nameKey === skuSp.nameKey)) || {}
          return !!skuSp.valueKey && findSp.checked
        } ).map(({valueKey}) => valueKey).join('-')
        // 处理sku参数
        let skuParams = [...this.skuParamsSchemas,...this.skuSearchImg]
        skuParams.forEach(skuParam => {
          const skuFieldDescriptorList = item.skuFieldDescriptorList || []
          const findItem = skuFieldDescriptorList.find(skuField => skuField?.name === skuParam?.name) || {}
          
          if (skuParam?.children?.length) {
            skuParam.children.forEach(skuParamChild => {
              const childList = findItem.children || []
              const childFindItem = childList.find(child => child?.name === skuParamChild?.name) || {}
              let key = skuParamChild.name
              if(key.indexOf('skuPicture') > -1){
                key = 'skuPicture'
              }
              item[key] = this.parseDefaultValue(skuParamChild, childFindItem.defaultValue)
            })
          } else if (skuParam?.name) {
            item[skuParam.name] = this.parseDefaultValue(skuParam, findItem.defaultValue) 
          }
        });
       
        return {
          ...item,
          _skuid
        }
      })
      this.self_form.skuList = _skuList
    },
    parseDefaultValue(propItem, defaultValue) {
      if(propItem.type === 'MULTICHECK') {
        try {
          if(!defaultValue) {
            return []
          }
          const parsedValue = JSON.parse(defaultValue)
           return Array.isArray(parsedValue) ? parsedValue : [];
        } catch (error) {
          return []
        }
      }
      return defaultValue || null
    },
    // 初始化sku参数
    initSkuParams() {
      let skuParamsSchemas = []
      let skuSearchImg = []
      // if(this.tbForm.showMode ==='multi-select') {
        const skuChildren = this.tbFormVm.schemas?.sku?.children || [];
        const skuQuality = skuChildren.find(item => item.name === 'skuQuality')
        if(skuQuality) {
          skuParamsSchemas.push(skuQuality)
          skuChildren.forEach(item => {
            if(item.name.startsWith('skuParam_')) {
              skuParamsSchemas.push(item)
            }else if(['skuPicture','skuTitle'].includes(item.name)){
              skuSearchImg.push(item)
            }
          })
        }
      // }
      this.skuSearchImg = skuSearchImg;
      this.skuParamsSchemas = skuParamsSchemas 
    },
    // 初始化尺码分组
    initSizeGroup() {
      if(this.tbForm.showMode ==='single-custom') {
        this.sizeValueObj = null
        this.sizeGroupObj = null
        return
      }
      // 先找到分组的配置对象
      this.saleProp.children.forEach(item => {
        item.children && item.children.forEach(citem => {
          if (citem.name.indexOf('-sizeGroup') > -1) {
            this.sizeGroupObj = citem
          }
          if (citem.name.indexOf('-sizeValue') > -1) {
            this.sizeValueObj = citem.children || []
          }
        })
      })
    },
    // 初始化尺码表
    initSizeMapping() {
      if(this.tbForm.showMode ==='single-custom') {
        this.sizeMappingsSchema = []
        this.isSizeMapRequired = false
        this.sizeNameKey = ''
        return
      }
      const sizeMapping = this.tbFormVm.schemas?.sizeMapping || {};
      this.sizeMappingsSchema = (sizeMapping.children || []).filter(item => item.name.startsWith('sizeMapping_'));
      this.isSizeMapRequired = sizeMapping.rules?.requiredRule === 'true'
      const noSizeMappings = (sizeMapping.children || []).filter(item => !item.name.startsWith('sizeMapping_'))
      let sizeNameKey = 'p-20509'
      if(noSizeMappings.length == 1) {
        sizeNameKey = noSizeMappings[0].name
      }
      this.sizeNameKey = sizeNameKey;
    },
    validateStdList() {
      return this.$refs.StdSizeExtendsRef ? this.$refs.StdSizeExtendsRef.validateStdList() : true;
    },
    // 获取相关数据
    method_getData() {
      let isGroup = 0
      if (!this.valiSkuImgs()) {
        return false
      }
      if (!this.validateSpecifications()) {
        return false
      } else {
        if(this.isPureType) {
          return [ [], [], {} ,0]
        }
        let [specifications, skuList] = this.getSpecificationData()
        let sizeGroup = {} // 尺码分组后端所需
        if (this.sizeGroupObj) {
          isGroup = 1
          // 若尺码分组存在
          // 获取当前所选的尺码分组
          const sizeGroupVal = this.tbForm[this.sizeGroupObj.name]
          if (!sizeGroupVal) {
            this.$message.error(`请选择${this.sizeGroupObj.label}`)
            return false;
          } else {
            // 根据所选分组得到其下的所有选项值
            for(const propName in this.propsMap) {
              if (this.propsMap[propName].propId === this.sizeGroupObj.parentName) {
                this.propsMap[propName].values = this.propsMap[propName].children.find(i => /sizeValue$/.test(i.name)).children.find(i => i.name.indexOf(sizeGroupVal) > -1).options
              }
            }
          }
        }
        const stdSizeExtendsData = this.$refs?.StdSizeExtendsRef?.method_getStdSizeData() || {}
        // 处理specifications中的values值，将propsMap中的value一一对应，若没有对应的，从-2开始自减作为自定义的value
        let _valueId = -2
        specifications = specifications.filter(sp => sp.checked)
        let optionsMap = {}
        specifications.forEach(sp => {
          const options = cloneDeep(this.propsMap[sp.name]?.values || [])
          const propId = this.propsMap[sp.name].propId.replace(/^p-/, '').replace(/^custom_/, '')
          sp.values.forEach(spv => {
            spv.valueKey = (spv.valueKey || spv.value).replace('______', '')
            const existOption = options.find(op => (op?.displayName || '') == spv.value)
            if (existOption && parseInt(existOption.value) > 0) {
              spv.propValueId = existOption.value
            } else {
              spv.propValueId = _valueId--
              !existOption && options.push({displayName: spv.value, value: spv.propValueId})
            }
            if(stdSizeExtendsData[spv.value]) {
              spv.extendValues = { ...stdSizeExtendsData[spv.value] }
            }
            spv.propId = propId

            if(!sp.valueAttributeRuleList.includes('img')) {
              delete spv.imageUrl
            } 
            delete spv.valueErrorMsg
            // if(!sp.valueAttributeRuleList.includes('remark')) {
            //   delete spv.note
            // }
          })
          optionsMap[sp.name] = options
          delete sp.formType
          delete sp.options
          delete sp.properties
          delete sp.valueAttributeRuleList
          delete sp.disabled
          delete sp.checked
        })
        // skuList中的skuSpecifications也需要加入propValueId, propId
        skuList.forEach(sku => {
          sku.skuSpecifications.forEach((skuSp, skuSpIndex) => {
            skuSp.valueKey = (skuSp.valueKey || skuSp.value).replace('______', '')
            if (skuSpIndex === 0) {
              // 取第一规格的图片赋给sku外层
              sku.imageUrl = skuSp.imageUrl
            }
            if (!this.propsMap[skuSp.name]){
              return;
            }

            const options = optionsMap[skuSp.name] || []
            const existOp = options.find(op => (op?.displayName || '') == skuSp.value)
            if (existOp) {
              skuSp.propValueId = existOp.value
            }
            skuSp.propId = this.propsMap[skuSp.name].propId.replace(/^p-/, '').replace(/^custom_/, '')
          })
          const needSkuFieldDescriptorList = this.skuTableCols_all.filter(item => item && !item.unvisible && (item.prop.startsWith('sku') || item.prop === 'outSkuPlatform')).map(item => item.prop)
          const skuFieldNames = [] 

          // 初始化或克隆skuFieldDescriptorList
          sku.skuFieldDescriptorList = sku.skuFieldDescriptorList ? [...sku.skuFieldDescriptorList] : [];
            // 处理已有字段
          sku.skuFieldDescriptorList.forEach(skuField => {
            skuField.defaultValue = sku[skuField.name];
            skuFieldNames.push(skuField.name)
          });
          // 处理sku参数 skuSearchImg
          let skuParams = [...this.skuParamsSchemas,...this.skuSearchImg];
          skuParams.map(skuParam => {
            const skuParamItem = {
              name: skuParam.name,
              defaultValue: this.transformDefaultValue(skuParam, sku[skuParam.name]) 
            };
            skuFieldNames.push(skuParam.name)
            if(skuParam.children?.length) {
              skuParamItem.children = skuParam.children.map(skuParamChild => {
                let valueKey = skuParamChild.name
                if(skuParam.name === 'skuPicture'){// sku搜索图特殊处理
                    valueKey = 'skuPicture'
                }
                const childItem = {
                  name: skuParamChild.name,
                  defaultValue: this.transformDefaultValue(skuParamChild, sku[valueKey]) 
                };
                skuFieldNames.push(skuParamChild.name)
                return childItem;
              });
            }
            const findIndex = sku.skuFieldDescriptorList.findIndex(skuField => skuField.name === skuParam.name)
            if(findIndex > -1) {
              sku.skuFieldDescriptorList.splice(findIndex, 1, skuParamItem)
            } else {
              sku.skuFieldDescriptorList.push(skuParamItem)
            }
          });
          // 添加必要字段
          needSkuFieldDescriptorList
          .filter(field => !sku.skuFieldDescriptorList.some(f => f.name === field))
          .forEach(field => {
            sku.skuFieldDescriptorList.push({
              name: field,
              defaultValue: sku[field]
            });
            skuFieldNames.push(field)
          });
          skuFieldNames.forEach(fieldName => {
            delete sku[fieldName]
          })
       })
        return [specifications, skuList, sizeGroup, isGroup]
      }
    },
    transformDefaultValue(prop, value) {
      if (prop.type === 'MULTICHECK') {
        try {
          return Array.isArray(value) ? JSON.stringify(value) : '';
        } catch (error) {
          return '';
        } 
      }
      return value || null;
    },
    specificationsFieldChanged() {
      this.$emit('fieldChanged')
    },
    handleImageUpload(v) {
      this.$emit('file-upload', v);
    },
    changePureType(val) {
      this.updateTbForm({pureType: val });
      if (!val) {
        this.handleSkuFieldBlur('skuStock'); // 计算一次总数量
      }
    },
    handleSearchImagesChanged(row,url,index){
      if(!url){
        this.$delete(this.skuList[index], 'skuPictureError')
      }
      this.$set(this.skuList[index],'skuPicture',url)
    },
    async handleImgLoad(row, refName,index) {
      let errMsg = await this.$refs[refName].method_validImage()
      if(errMsg){
        this.$set(this.skuList[index],'skuPictureError',errMsg)
      }else{
        this.$delete(this.skuList[index], 'skuPictureError')
      }
    },
    validateSkuPictureImages(value, prop,row){
      let errMsg
      if(prop?.attrs?.noRequired && !value){
        errMsg = 'SKU搜索图不能为空'
      }
      if(row.skuPictureError){
        errMsg = 'SKU搜索图：' + row.skuPictureError
      }
      return errMsg ? errMsg : true;
    },
    getOptions(){
      return this.$refs.radioRef.getOptions()
    },
  }
}
</script>

<style lang="scss" scoped>
.help-icon {
  margin: -2px 5px 0;
  font-size: 14px;
}
.wrap {
  .wrap-item {
    display: flex;
    .wrap-item_label {
      width: 12%;
      font-size: 12px;
      padding-right: 6px;
      text-align: right;
      flex-shrink: 0;
    }
    .wrap-item_content {
      flex: 1;
      overflow-x: hidden;
    } 
  }
  .required-label {
    &::before {
        content: "*";
        color: #f56c6c;
        margin-right: 4px;
        box-sizing: border-box;
      }
  }
  .wrap-item + .wrap-item {
    margin-top: 20px;
  }
  ::v-deep .el-table{
    .el-form-item__error{
        margin-left: 0 !important;
        text-align: left;
    }
  }
}

</style>
